import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env";
import { Observable } from "rxjs";
import { ErrorHandlingService } from "src/app/features/ada-access/shared/errorHandling/errorHandling.service";
import { API_ENDPOINTS } from "../../secure-blockchain-api-endpoints";
import { catchError, map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    private baseUrl = environment.apiUrl;

    constructor(
        private http: HttpClient,
        private errorHandlingService: ErrorHandlingService
    ) { }


      getSbcDashboard(): Observable<any> {
        return this.http
          .post<any>(
            `${this.baseUrl}${API_ENDPOINTS.DASHBOARD.FETCH}`,
            { }
          )
          .pipe(
            map((response) => response),
            catchError((error) => this.errorHandlingService.handleError(error))
          );
      }
}